import React, { useEffect, useState } from 'react'
import TableStepper from './StepperComponent'
import { Box, Button, CircularProgress, Collapse, Grid, makeStyles, TableCell, TableRow, Typography } from '@material-ui/core'
import BatchDetailsRow from './BatchDetailsRow'
import axios from 'axios'
import UploadRecord from './uploadRecords/index'
import { appUrl } from '../../../../../../../utils/config'

const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(3),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        // width: '100%',
        // backgroundColor: '#EDEDED',
    },
}))


const BatchDetailsUnitBox = (props) => {
  const { batchDetails, view, featureAccess } = props;
  const classes = useStyles()
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
    const [batchUnitData, setBatchUnitData] = useState(null);
    const [openDialogBox, setDialogBox] = useState(false);
  
    useEffect(() => {
        setIsLoading(true)
    let data = {
        collabrixWorkItemID: 0,
        schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID
      }
      setIsLoading(true)
      setBatchUnitData(null)
  axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchBatchUnitOperationDetails`,
      data
    )
    .then((res) => {
      if (res.data.status) {
        setIsLoading(false)
        setBatchUnitData(res.data.data)
      } else {
        setIsLoading(false)
        setError(true)
      }
    })
    .catch((err) => {
      setError(true)
      setIsLoading(false)
      console.log(err)
    });
  }, [batchDetails?.schrockenDeliveryScheduleBatchID, openDialogBox])
    
    const handleDialogBox = () => {
        setDialogBox(!openDialogBox)
    }

  return (
    <Box margin={4}>
      <Grid container spacing={3} style={{border:'1px solid rgba(0, 0, 0, 0.12)'}}>
      <Grid container justifyContent='space-between' alignItems='center' style={{padding:'24px'}}>
                      <Grid item>
                      <BatchDetailsRow data={batchDetails} />
                      </Grid>
                  <Grid item>
                      {featureAccess?.fgBatchUploadProcessInformation && localStorage.collabType === 'CMO' && !view && (
                          <Button style={{textTransform:'none'}}  variant="contained" color="primary" onClick={handleDialogBox} >
                          Upload process information
                        </Button>
                      )}
                      
                      </Grid>
          </Grid>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center", // Horizontally center the CircularProgress
                alignItems: "center", // Vertically center the CircularProgress
              height: "100px", // Optional: Set a height to vertically center the loader
                width:'100%'
              }}
            >
              <CircularProgress />
            </div>
          ) : (
              

                    error ? <Box className={classes.root} style={{width:'100%',border: '2px solid #FF0000',
                backgroundColor: '#FFF0F0'}}>
                        <Typography style={{textAlign:'center'}}>Something went wrong. Please try again.</Typography>
                    </Box> :
                      (batchUnitData && Object.keys(batchUnitData).length !== 0) 
                ? <Box className={classes.root}>
                                  <TableStepper batchData={batchUnitData} stepperData={batchUnitData?.unitOperationDetails} batchDetails={batchDetails} />
                  </Box>
                  : <Box className={classes.root} style={{ width: '100%' }}>
                        <Typography style={{textAlign:'center'}}>No Records Found</Typography>
                    </Box>
             
          )}
          </Grid>
          {openDialogBox && <UploadRecord open={openDialogBox} close={handleDialogBox} batchDetails={batchDetails} />}
  </Box>
    
  )
}

export default BatchDetailsUnitBox